function getDropdownElements(toggle) {
  let menuId = toggle.getAttribute("aria-controls");
  if (!menuId && toggle.dataset.dropdownTarget) {
    menuId = toggle.dataset.dropdownTarget;
    toggle.setAttribute("aria-controls", menuId);
    console.warn(
      "[Dropdown] Added is missing `aria-controls` attribute",
      toggle
    );
  }
  if (!menuId) {
    console.warn(
      "[Dropdown] Toggle missing `aria-controls` and `data-dropdown-target`:",
      toggle
    );
    return null;
  }
  const menu = document.getElementById(menuId);
  if (!menu) {
    console.warn(`[Dropdown] No dropdown menu found with id '${menuId}'`);
    return null;
  }
  const items = Array.from(
    menu.querySelectorAll("[data-dropdown-item]")
  );
  return { toggle, menu, items };
}
function positionDropdown(dropdown) {
  const { toggle, menu } = dropdown;
  menu.style.setProperty("--toggle-height", `${toggle.offsetHeight}px`);
  menu.style.setProperty("--menu-width", `${menu.offsetWidth}px`);
}
function closeDropdown(dropdown) {
  dropdown.toggle.classList.remove("is-open");
  dropdown.toggle.setAttribute("aria-expanded", "false");
  dropdown.menu.classList.remove("is-open");
  dropdown.items.forEach((item) => item.setAttribute("tabindex", "-1"));
  document.removeEventListener("click", dropdown.toggle.handleOutsideClick);
  document.removeEventListener("keyup", dropdown.toggle.handleEsc);
}
function openDropdown(dropdown) {
  document.querySelectorAll(
    '[data-dropdown-toggle].is-open[aria-expanded="true"]'
  ).forEach((openToggle) => {
    const openDropdownElements = getDropdownElements(openToggle);
    if (openDropdownElements && openDropdownElements.menu !== dropdown.menu) {
      closeDropdown(openDropdownElements);
    }
  });
  positionDropdown(dropdown);
  dropdown.toggle.classList.add("is-open");
  dropdown.toggle.setAttribute("aria-expanded", "true");
  dropdown.menu.classList.add("is-open");
  dropdown.items.forEach((item) => item.setAttribute("tabindex", "0"));
  document.addEventListener("click", dropdown.toggle.handleOutsideClick);
  document.addEventListener("keyup", dropdown.toggle.handleEsc);
}
function initDropdowns() {
  const toggles = document.querySelectorAll(
    "[data-dropdown-toggle]"
  );
  toggles.forEach((toggle) => {
    if (!toggle.hasAttribute("aria-expanded")) {
      toggle.setAttribute("aria-expanded", "false");
    }
    if (!toggle.hasAttribute("aria-controls") && toggle.dataset.dropdownTarget) {
      toggle.setAttribute("aria-controls", toggle.dataset.dropdownTarget);
    }
    const dropdown = getDropdownElements(toggle);
    if (!dropdown) return;
    closeDropdown(dropdown);
    toggle.removeEventListener("click", toggle.handleToggleClick);
    toggle.removeEventListener("keydown", toggle.handleKeydown);
    toggle.handleToggleClick = (e) => {
      e.stopPropagation();
      const isOpen = dropdown.menu.classList.contains("is-open");
      if (!isOpen) {
        openDropdown(dropdown);
      } else {
        closeDropdown(dropdown);
      }
    };
    toggle.handleOutsideClick = (e) => {
      const target = e.target;
      if (!dropdown.menu.contains(target) && !dropdown.toggle.contains(target)) {
        closeDropdown(dropdown);
      }
    };
    toggle.handleEsc = (e) => {
      if (e.key === "Escape") {
        closeDropdown(dropdown);
      }
    };
    toggle.handleKeydown = (e) => {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        toggle.handleToggleClick(e);
      }
    };
    if (toggle.handleToggleClick) {
      toggle.addEventListener("click", toggle.handleToggleClick);
    }
    if (toggle.handleKeydown) {
      toggle.addEventListener("keydown", toggle.handleKeydown);
    }
  });
  document.addEventListener("click", (e) => {
    const target = e.target;
    if (!target.closest("[data-dropdown-toggle]") && !target.closest("[data-dropdown-menu]")) {
      document.querySelectorAll(
        '[data-dropdown-toggle].is-open[aria-expanded="true"]'
      ).forEach((openToggle) => {
        const openDropdownElements = getDropdownElements(openToggle);
        if (openDropdownElements) {
          closeDropdown(openDropdownElements);
        }
      });
    }
  });
}
export {
  initDropdowns
};
//# sourceMappingURL=index.js.map
